import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom'
import { Redirect } from "react-router-dom";
export default class PageNotFound extends PureComponent {
  render() {
    //重定向
    let { pathname } = this.props.history.location;
    if (pathname.startsWith('/courseList')) {
      return <Redirect to="/courseList/0-0-0" />
    } else if (pathname.startsWith('/coursepacklist')) {
      return <Redirect to="/coursepacklist/0-0-0" />
    } else if (pathname.startsWith('/select')) {
      return <Redirect to="/select/0/0-0-0" />
    }
    return (
      <div className="common-page-not-found">
        <div className='error_wrap'>
          <div className='error_content'>
            <img className='error_img' src={require('../../images/error_bg.png')} alt="" />
            <p className='error_tip'>您访问的页面不存在了</p>
            <Link className='error_link' to="/" >返回首页</Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/PageNotFound.js